let model = {};

model.dataForm = {
  nguoi_gui_id: null, //IdRef, optional // Mã người phản hồi
  nhom_phan_hoi: null, //IdRef, optional // Mã nhóm phản hồi, nếu null hoặc missing tương đương với 'Khác'
  cong_ty_lu_hanh_id: null, //IdRef, optional // Mã công ty lữ hành nhận phản hồi, nếu null hoặc missing thì là phản hồi tới cơ quan quản lý
  thoi_diem_phan_hoi: null, //datetime, optional // Thời điểm phản hồi
  tour_id: null, //IdRef, optional // Mã tour mà người dùng muốn phản hồi
  noi_dung: null, //string, required, minLength: 1 // Nội dung phản hồi
  file_dinh_kem: [], //array of IdRef, optional // Danh sách ảnh/video đính kèm
  trang_thai: null, //string, optional // Trạng thái xử lý
  // trang_thai_tcqltt: null, //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
  tcqltt: [], //object, optional // Các dữ liệu phát sinh khi chuyển sang tổng cục quản lý thị trường
  loc: {
    //object, optional // Thông tin tọa độ (theo chuẩn GeoJSON)
    type: null, //string, optional // Fix cứng là Point
    coordinates: [], //array of double, optional // Thông tin tọa độ
  },
};

// validation form
model.validForm = {
  nguoi_gui_id: [], //IdRef, optional // Mã người phản hồi
  nhom_phan_hoi: [], //IdRef, optional // Mã nhóm phản hồi, nếu null hoặc missing tương đương với 'Khác'
  cong_ty_lu_hanh_id: [], //IdRef, optional // Mã công ty lữ hành nhận phản hồi, nếu null hoặc missing thì là phản hồi tới cơ quan quản lý
  thoi_diem_phan_hoi: [], //datetime, optional // Thời điểm phản hồi
  tour_id: [], //IdRef, optional // Mã tour mà người dùng muốn phản hồi
  noi_dung: [], //string, required, minLength: 1 // Nội dung phản hồi
  file_dinh_kem: [], //array of IdRef, optional // Danh sách ảnh/video đính kèm
  trang_thai: [], //string, optional // Trạng thái xử lý
  // trang_thai_tcqltt: [], //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
  tcqltt: [], //object, optional // Các dữ liệu phát sinh khi chuyển sang tổng cục quản lý thị trường
  loc: {
    //object, optional // Thông tin tọa độ (theo chuẩn GeoJSON)
    type: "Point", //string, optional // Fix cứng là Point
    coordinates: [], //array of double, optional // Thông tin tọa độ
  },
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
  tcqltt: {
    //object, optional // Các dữ liệu phát sinh khi chuyển sang tổng cục quản lý thị trường
    nguoi_xu_ly_id: null, //IdRef, optional // Mã người được phân công xử lý
    trang_thai: null, //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
    lich_su: [], //array of object, optional // Danh sách lịch sử chuyển phản hồi
  },
  lich_su: {
    //array of object, optional // Danh sách lịch sử chuyển phản hồi
    tu: null, //IdRef, optional // Từ người
    den: null, //IdRef, optional // Đến người
    ly_do: null, //string, optional // Lý do chuyển
    thoi_diem: null, //datetime, optional // Thời điểm chuyển
    file_dinh_kem: [], // array of IdRef, optional // Danh sách ảnh/video đính kèm
    trang_thai: null, //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
  },
  fileUploadOption: {
    AnhDaiDien: {
      limit: 1,
      accept: ".jpg, .png, .jpeg, .mp4",
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
    },
    FileDinhKem: {
      limit: null,
      accept: "",
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
    },
    FileDinhKemTCQLTT: {
      limit: null,
      accept: "",
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
    },
  },
  ten_doi_tuong_phan_hoi: "",
  ten_don_vi: "",
};

// validation các form khác
model.validFormOther = {
  tcqltt: {
    //object, optional // Các dữ liệu phát sinh khi chuyển sang tổng cục quản lý thị trường
    nguoi_xu_ly_id: [], //IdRef, optional // Mã người được phân công xử lý
    trang_thai: [], //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
    lich_su: [],
  },
  lich_su: {
    //array of object, optional // Danh sách lịch sử chuyển phản hồi
    tu: [], //IdRef, optional // Từ người
    den: [], //IdRef, optional // Đến người
    ly_do: [], //string, optional // Lý do chuyển
    thoi_diem: [], //datetime, optional // Thời điểm chuyển
    file_dinh_kem: [],
    trang_thai: [], //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
  },
};

model.validFormOther = {
  tcqltt: {
    //object, optional // Các dữ liệu phát sinh khi chuyển sang tổng cục quản lý thị trường
    nguoi_xu_ly_id: [], //IdRef, optional // Mã người được phân công xử lý
    trang_thai: [], //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
    lich_su: [],
  },
  lich_su: {
    //array of object, optional // Danh sách lịch sử chuyển phản hồi
    tu: [], //IdRef, optional // Từ người
    den: [], //IdRef, optional // Đến người
    ly_do: [], //string, optional // Lý do chuyển
    thoi_diem: [], //datetime, optional // Thời điểm chuyển
    file_dinh_kem: [],
    trang_thai: [], //string, optional // Trạng thái xử lý của tổng cục quản lý thị trường
  },
};

model.trangThai = [
  {
    code: "new",
    text: "Mới",
  },
  {
    code: "processing",
    text: "Đang xử lý",
  },
  {
    code: "processed",
    text: "Đã xử lý",
  },
  {
    code: "forwarded_to_tcqltt",
    text: "Đã chuyển tới TCQLTT",
  },
];

model.trangThaiTcqltt = [
  {
    code: "new",
    text: "Mới",
  },
  {
    code: "processing",
    text: "Đang xử lý",
  },
  {
    code: "waiting",
    text: "Chờ duyệt",
  },
  {
    code: "processed",
    text: "Hoàn thành",
  },
];

model.doiTuongPhanHoi = [
  {
    code: true,
    text: "Công ty lữ hành",
  },
  {
    code: false,
    text: "Cơ quan quản lý",
  },
];

model.doiTuong = [
  {
    code: "DNLH",
    text: "Doanh nghiệp lữ hành",
  },
  {
    code: "TOUR",
    text: "Tour",
  },
  {
    code: "HDV",
    text: "Hướng dẫn viên",
  },
  {
    code: "CSLT",
    text: "Cơ sở lưu trú",
  },
  {
    code: "DDAT",
    text: "Đơn vị cung cấp",
  },
];
model.tableRules = {
  data: [],
  lengthMenu: [25, 50, 75, 125, 525],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 25,
  offset: 0,
  sort: "",
  defaultSort: ["thoi_diem_phan_hoi", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      ten_nguoi_gui: "",
      nguoi_gui_id: "",
      thoi_diem_phan_hoi: "",
      "tcqltt.trang_thai": "",
      "doi_tuong_phan_hoi.doi_tuong": "",
      // loai_phan_hoi: 'kdl'
    },
    valid: {
      ten_nguoi_gui: [],
      nguoi_gui_id: [],
      thoi_diem_phan_hoi: [],
    },
    operator: {
      ten_nguoi_gui: ":regex_i:", //:regex:, $vn_text=Viêt nam
      thoi_diem_phan_hoi: ":in_that_day:",
    },
  },
};

export default model;
